import { Input, Directive, input } from "@angular/core";
import { NgForm, NgModel } from "@angular/forms";
import { SelectItem } from 'primeng/api';
import { SharedControl } from "../../classes/sharedcontrol";
import { Lot } from "../../types";

@Directive()
export abstract class PCPLotSelectorBaseComponent extends SharedControl {
    readonly marketId = input<number>(undefined);
    // TODO: Skipped for migration because:
    //  This input is inherited from a superclass, but the parent cannot be migrated.
    @Input() disabled: boolean = false;
    readonly selectionLimit = input<number>(null);
    readonly required = input<boolean>(false);
    readonly parentForm = input<NgForm>(null);
    readonly isOneOfManyRequired = input<boolean>(false);
    readonly isMultiCommunityLotList = input<boolean>(false);
    readonly xOfManyErrors = input<boolean>(false);

    registerControlWithParent(model: NgModel) {
        const parentForm = this.parentForm();
        if (!parentForm || parentForm === null) { return; }

        parentForm.addControl(model);
    }

    lotsToOptions(lots: Lot[]): SelectItem[] {
        return lots.map((lot) => {
            if (this.isMultiCommunityLotList()) {
                const displayText = `(${lot.community.sourceKey}) ${lot.lotBlock} - ${lot.streetAddress1 || ""}`;
                return { label: displayText, value: lot };
            }

            const displayText = `${lot.lotBlock} (${lot.streetAddress1})`;
            return { label: displayText, value: lot };
        });
    }

    sortSelectedTop(allLots: Lot[], selectedLots: Lot[]): Lot[] {
        if (!allLots || allLots.length === 0) { return []; }

        const unselectedLots = allLots.filter((lot) => !this.lotIsInSelectedLots(lot, selectedLots));
        const selectLots = allLots.filter((lot) => this.lotIsInSelectedLots(lot, selectedLots));

        const alphabetically = (a: Lot, b: Lot) => (a.lotBlock > b.lotBlock) ? 1 : -1;
        const alphabeticallySortedUnselectedLots = unselectedLots.sort(alphabetically);
        const alphabeticallySortedSelectedLots = selectLots.sort(alphabetically);

        alphabeticallySortedUnselectedLots.unshift(...alphabeticallySortedSelectedLots);

        const allSortedLots = alphabeticallySortedUnselectedLots;

        return allSortedLots;
    }

    private lotIsInSelectedLots(lot: Lot, selectedLots: Lot[]): boolean {
        if (!selectedLots || selectedLots.length === 0) { return false; }

        return selectedLots.some((selectedLot) => selectedLot.lotBlock === lot.lotBlock);
    }
}
